import React, { useEffect, useState, useCallback } from 'react';
import DialogTitle from '@mui/material/DialogTitle';
import Dialog from '@mui/material/Dialog';
import DialogContentText from '@mui/material/DialogContentText';
import DialogContent from '@mui/material/DialogContent';
import { Box, Button, TextField, Modal } from '@mui/material';
import { IconButton } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import { useDropzone } from 'react-dropzone';
import Autocomplete from '@mui/material/Autocomplete';
import AddSingleContact from './AddSingleContact';
import toast from 'react-hot-toast';
import LeadService from '../../core/services/leadsService';
const options = [
    { label: 'Lofty', value: 'lofty' },
    { label: 'Kuvcore', value: 'kuvcore' },
];
const ImportContacts = ({openContact,setOpenContact,handleOpenContact}) => {
    const handleClose = () => {
        setOpenContact(false);
    };
    return (
        <>
            <div>
                <Dialog
                    open={openContact}
                    onClose={handleClose}
                    PaperProps={{
                        sx: {
                            borderRadius: '16px',
                            boxShadow: '0px 8px 24px rgba(0, 0, 0, 0.15)',
                            padding: '24px',
                        },
                    }}
                >
                    <DialogTitle>
                        <Box sx={{ display: 'flex', justifyContent: 'space-between' }}>
                            <div>
                                <span>Import Contact</span>
                            </div>
                            <div>
                                <IconButton onClick={handleClose}>
                                    <CloseIcon />
                                </IconButton>
                            </div>
                        </Box>
                    </DialogTitle>
                    <DialogContent>
                        <DialogContentText
                            id="alert-dialog-description"
                            sx={{
                                textAlign: 'center',
                                fontFamily: "'Roboto', sans-serif",
                                color: '#555',
                                fontSize: '16px',
                                marginBottom: '24px',
                            }}
                        >
                            <Box
                                sx={{
                                    display: 'flex',
                                    justifyContent: 'center',
                                    gap: '16px',
                                    flexDirection: 'column',
                                    alignItems: 'center',
                                    width: '400px',
                                }}
                            >
                                <AddSingleContact setOpenImportContact={setOpenContact}/>
                            </Box>
                        </DialogContentText>
                    </DialogContent>
                </Dialog>
            </div>
        </>
    );
};

export default ImportContacts;
